<template>
  <router-view />
  <!-- Footer -->
  <section class="container-fluid footer-color">
    <div class="container-xxl py-3 text-light">
      <div class="col-xs-12 col-md-auto">
        <p class="text-light text-center pt-3 pb-0">© Copyright Inside CKD</p>
      </div>
      <div class="row mt-3 mb-4 g-2 mx-0 justify-content-md-center align-items-center border-bottom border-light pb-4 text-center">
        <div class="col-xs-12 col-md-auto">
          <a href="//policy.cookiereports.com/a4b8a11c-en-gb.html" class="CookieReportsLink">Cookie Policy</a><span class="pipe d-none d-md-inline">|</span>
        </div>
        <div class="col-xs-12 col-md-auto">
          <a href="https://www.azprivacy.astrazeneca.com/" target="_blank">Privacy Policy</a><span class="pipe d-none d-md-inline">|</span>
        </div>
        <div class="col-xs-12 col-md-auto">
          <a href="https://www.astrazeneca.com/legal-notice-and-terms-of-use.html" target="_blank">Legal Notice</a><span class="pipe d-none d-md-inline">|</span>
        </div>
        <div class="col-xs-12 col-md-auto">
          <a href="https://www.astrazeneca.com/our-company/contact-us.html" target="_blank">Contact</a>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <p class="text-light text-center"><small>Date of preparation: May 2025</small></p>
          <p class="text-light text-center"><small>Veeva ID: Z4-72230</small></p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex justify-content-center justify-content-sm-end">
          <img src="/img/az-footer-logo.png" alt="" class="footer-logo">
        </div>
      </div>
    </div>

    <!-- HCP Modal -->
    <div class="modal fade" id="hcpModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="hcpModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content m-2 m-sm-5">
          <div class="justify-content-center hcp-modal">
            <h3 class="modal-title text-center pt-4" id="hcpModalLabel">Welcome to Inside CKD</h3>
          </div>
          <div class="modal-body text-center pb-0 ps-4 pe-4 ms-4 me-4">
            <p>This website is a non-promotional global resource intended for healthcare professionals, healthcare policy makers and other relevant stakeholders in healthcare policy. Please select your role below.</p>
          </div>
          <div class="row ms-3">
            <div class="col-12">
              <p class="text-start pt-1 mb-1">I am a...</p>
            </div>
          </div>
          <div class="row ms-2 me-3 mb-4 align-items-center justify-content-center ps-0 pe-0">
            <div class="col-10 text-center flex-sm-grow-1 justify-content-center">
              <select id="hcpSelect" class="form-select explore-dropdown border-0 d-flex" v-model="audience_type">
                <option selected disabled value="">please select</option>
                <option value="nephrologist">Nephrologist</option>
                <option value="primary_care">Primary Care Physician</option>
                <option value="other_hcp">Other healthcare professional</option>
                <option value="policy_maker">Healthcare decision maker or policy maker</option>
                <option value="other_stakeholder">Other relevant stakeholder</option>
              </select>
            </div>
            <button type="button" id="hcpButton" class="hcp-selected" data-bs-dismiss="dropdown" aria-label="Close" disabled @click="hcpOptionSelected()"></button>
          </div>

          <div class="text-center pb-3">
            <p><a class="modal-link small" href="https://www.astrazeneca.com/global/en/AstraZeneca-Websites.html" target="_blank">If you are a member of the public, please visit the AstraZeneca site in your country here</a></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Modal } from "bootstrap";

export default {

  data() {
    return {
      // Preferred would be camel case for this but it needs to match Jons analytics tracking
      audience_type: ''
    }
  },
  mounted() {
    this.hcpCheck();
    this.audience_type = localStorage.getItem('audience_type') || '';
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      })
    },
    hcpCheck() {
      if (!localStorage.audience_type) {
        // Show modal
        new Modal('#hcpModal', {}).show();
        // Toggle disable button
        let hcpSelect = document.getElementById('hcpSelect');
        let hcpBtn = document.getElementById('hcpButton');
        hcpSelect.addEventListener('change', function() {
          hcpBtn.disabled = !this.value;
        })
      }
    },
    hcpOptionSelected() {
      if(this.audience_type) {
        localStorage.setItem('audience_type', this.audience_type);
        // Close modal
        Modal.getInstance('#hcpModal').hide();
      }
    },
  },
  watch: {
    '$route': function(to, from) {
      this.scrollToTop()
    }
  }
};
</script>
